namespace GeniuzPOS.Points {
    export interface MemberTypeForm {
        MemberType: Serenity.StringEditor;
        MemberTypeDesc: Serenity.StringEditor;
        MbPriceFg: Serenity.IntegerEditor;
        MbDiscPs: Serenity.DecimalEditor;
        SellUnitPriceNo: Serenity.IntegerEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        UpdateBy: Serenity.StringEditor;
        LastUpdate: Serenity.DateEditor;
        DtList: PrPointCampaignEditor;
    }

    export class MemberTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Points.MemberType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MemberTypeForm.init)  {
                MemberTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = PrPointCampaignEditor;

                Q.initFormType(MemberTypeForm, [
                    'MemberType', w0,
                    'MemberTypeDesc', w0,
                    'MbPriceFg', w1,
                    'MbDiscPs', w2,
                    'SellUnitPriceNo', w1,
                    'CreateBy', w0,
                    'CreateDate', w3,
                    'UpdateBy', w0,
                    'LastUpdate', w3,
                    'DtList', w4
                ]);
            }
        }
    }
}
